import serverCall from "../serverCall";

const getAllAdmin = (page, limit, search, userType) => {
  try {
    const q = encodeURIComponent(search ?? "");
    const response = serverCall.get(
      `/superAdmin/get-all-admin?page=${page}&limit=${limit}&search=${q}&userType=${userType}`
    );
    return response;
  } catch (error) {
    throw error;
  }
};

const getSingleAdmin = (userId) => {
  try {
    const response = serverCall.get(`/superAdmin/get-admin?userId=${userId}`);
    return response;
  } catch (error) {
    throw error;
  }
};

const getProfile = () => {
  try {
    const response = serverCall.get(`/superAdmin/get-profile`);
    return response;
  } catch (error) {
    throw error;
  }
};

const deleteAdmin = (userId) => {
  try {
    const response = serverCall.delete(
      `/superAdmin/delete-admin?userId=${userId}`
    );
    return response;
  } catch (error) {
    throw error;
  }
};

const createAdmin = (body) => {
  try {
    const response = serverCall.post(`/superAdmin/create-admin`, body);
    return response;
  } catch (error) {
    throw error;
  }
};

const updateAdmin = (userId, body) => {
  try {
    const response = serverCall.patch(
      `/superAdmin/update-admin?userId=${userId}`,
      body
    );
    return response;
  } catch (error) {
    throw error;
  }
};

const updateSuperAdminProfile = (body) => {
  try {
    const response = serverCall.patch(`/superAdmin/update-profile`, body);
    return response;
  } catch (error) {
    throw error;
  }
};

const getInquiries = (page, limit, search = "") => {
  try {
    const q = encodeURIComponent(search ?? "");
    const response = serverCall.get(
      `/subscription/contact-sales?page=${page}&limit=${limit}&search=${q}`
    );
    return response;
  } catch (error) {
    throw error;
  }
};

const updateInquiryStatus = (id, body) => {
  try {
    const response = serverCall.patch(`/subscription/contact-sales/${id}`, body);
    return response;
  } catch (error) {
    throw error;
  }
};

const SuperAdminService = {
  createAdmin,
  getAllAdmin,
  getSingleAdmin,
  getProfile,
  deleteAdmin,
  updateAdmin,
  updateSuperAdminProfile,
  getInquiries,
  updateInquiryStatus,
};

export default SuperAdminService;
